var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"detail-header",domProps:{"innerHTML":_vm._s(_vm.detailData.description)}}),(_vm.detailData.img)?_c('div',{staticStyle:{"position":"relative","padding":"20px"}},[_c('van-image',{attrs:{"width":'100%',"height":"100%","fit":"cover","src":_vm.detailData.img}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }